/*
 * @Author: YuanYuan
 * @Date: 2025-06-25 17:00:30
 * @LastEditTime: 2025-08-28 11:13:22
 * @Description: 安全设置
 */
import i18n from '@/i18n'

const Meta = {
  leftMenuCode: 'User',
  leftActiveIndex: '/securitySet'
}

export default [
  {
    path: '/securitySet',
    meta: {
      ...Meta,
      title: i18n.t('menu.securitySetting')
    },
    component: () => import('@/views/securitySet/index.vue')
  },
  {
    path: '/securitySet/paySet',
    meta: {
      ...Meta,
      title: i18n.t('menu.setPayPwd'),
      backable: true
    },
    component: () => import('@/views/securitySet/paySet.vue')
  },
  {
    path: '/securitySet/emailSet',
    meta: {
      ...Meta,
      title: i18n.t('menu.setEmail'),
      backable: true
    },
    component: () => import('@/views/securitySet/emailSet.vue')
  },
  {
    path: '/securitySet/loginSet',
    meta: {
      ...Meta,
      title: i18n.t('menu.modifyPassword'),
      backable: true
    },
    component: () => import('@/views/securitySet/loginSet.vue')
  }
]